import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
						<article class="has-widget">
							<p>DolphinHost™ mākoņskaitļošanas datu centrā izvietots videonovērošanas kameru ieraksta serveris. Iespēja apskatīt videonovērošanas kameras reālā laika režīmā pieslēdzoties attālināti ar lietotājvārdu, paroli un kodu kalkulatoru. </p>
							<h2>Priekšrocības</h2>
							<ul>
								<li>Drošs videonovērošanas serveris</li>
								<li>Aizsardzība pret datu zudumiem (visi videoieraksti tiek glabāti 3 kopijās uz fizisiki neatkarīgām iekārtām).</li>
								<li>Iespēja ērti pārskatīt video ierakstus</li>
								<li>Datu centra un videoierakstu uzglabāšanas infrastruktūras atbilstība GDPR datu aizsardzības regulai</li>
							</ul>
						</article>
						<div class="widget plan">
							<h3><span class="from"><Text id="cart.from"/></span><span class="value">€20</span><span class="term"> <Text id="cart.month.full"/></span></h3>
						     <ul class="bullet">
						     	<li>Bezmaksas ierīkošana</li>
						     	<li>10% atlaide maksājot par 12 mēnešiem</li>
						     </ul>
						     <div><Link href={store.prefix+'/contact?service=surveillance&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
						</div>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/surveillance.js